module.exports = __webpack_public_path__ + "img/caigou3.26e95c65.png";